const styles = {
    container: {
        alignItems: 'stretch',
        backgroundColor: 'green',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}

export { styles as footerStyles };


// WEBPACK FOOTER //
// ./src/js/components/Footer/styles.ts